<div class="flex flex-col justify-between">
	<div class="flex justify-between">
		<h2>Response to requisitions</h2>

		<label
			class="text-green underline cursor-pointer ml-5 flex items-center mt-2 text-lg"
			(click)="toggleDetails()"
			>{{ showDetails ? 'Hide details' : 'Show details' }}</label
		>
	</div>
	<div [@openClose] *ngIf="showDetails">
		<app-container type="dark" class="w-full h-full mt-4">
			<div class="flex justify-between w-full">
				<div class="flex w-max">
					<app-date-picker
						[ngModel]="titleSearchCompletionDate"
						(ngModelChange)="setRequisitionDate($event)"
						label="Requisition date"
						class="mr-2"
						maxDate="{{ closingDate }}"
						maxDateErrorLabel="Closing Date"
					></app-date-picker>
					<app-date-picker
						[ngModel]="requisitionStatus?.requisitionLetterDate"
						label="Date of requisition letter"
						(ngModelChange)="setRequisitionLetterDate($event)"
						class="ml-2"
					></app-date-picker>
				</div>
				<div class="flex items-end w-max">
					<app-checkbox
						[ngModel]="requisitionStatus?.received"
						label="Requisition received on time"
						(ngModelChange)="setRequisitionRecieved($event)"
					></app-checkbox>
					<app-checkbox
						class="ml-2"
						[ngModel]="requisitionStatus?.sent"
						label="Response sent"
						(ngModelChange)="setRequisitionSent($event)"
					></app-checkbox>
				</div>
			</div>
		</app-container>
	</div>
</div>

<div class="w-full flex mt-4">
	<div class="w-1/2 mr-2 flex flex-col h-full">
		<h4 class="mb-2">Requisition letter</h4>
		<app-container
			type="dark"
			class="flex flex-1 justify-center items-center"
			*ngIf="!latestRequisitionFile?.url"
		>
			<div class="flex flex-1 h-full justify-center items-center">
				<app-sale-file-upload
					label="Upload Requisitions"
					type="dropzone"
					[documentName]="fileName"
					[documentType]="docType"
					[saleId]="matterId"
				></app-sale-file-upload>
			</div>
		</app-container>

		<app-matter-url-pdf-viewer
			*ngIf="latestRequisitionFile"
			[googleSrcUrl]="latestRequisitionFile?.url"
			[fileName]="latestRequisitionFile?.name"
			[fileType]="latestRequisitionFile?.fileType"
			class="h-full"
		>
		</app-matter-url-pdf-viewer>
	</div>

	<div class="w-1/2 flex flex-col h-full">
		<ng-container
			*ngIf="responseToRequisitionsDocSourceIdByMatterType$ | async as sourceId"
		>
			<app-documents-word-matter-viewer
				*ngIf="!(useHtmlDocuments$ | async)"
				sourceId="{{ sourceId }}"
				class="h-full"
			></app-documents-word-matter-viewer>
		</ng-container>
		<app-document-matter-viewtor
			*ngIf="useHtmlDocuments$ | async"
			class="h-full"
			sourceId="rtr"
		></app-document-matter-viewtor>
	</div>
</div>
